import $ from 'jquery'
import _ from 'lodash'
import { elementExists } from './shared'

const ELEMENT_ID_1 = '#money-send-time-first'
const ELEMENT_ID_2 = '#money-send-time-second'
const ELEMENT_ID_3 = '#money-send-time-third'

const ELEMENT_ID_4 = '#money-send-time-fourth'
const ELEMENT_ID_5 = '#money-send-time-fifth'
const ELEMENT_ID_6 = '#money-send-time-sixth'

const getRandomTime = (min, max) => {
    const steps = _.range(min, max + 1, 1).filter((n) => n % 2 === 1) // jen lichá čísla

    return _.sample(steps)
}

export default function () {
    if (elementExists(ELEMENT_ID_1) && elementExists(ELEMENT_ID_2) && elementExists(ELEMENT_ID_3)) {
        const times = {
            first: getRandomTime(1, 20),
            second: getRandomTime(20, 40),
            third: getRandomTime(40, 60),
        }

        $(ELEMENT_ID_1).text(`🕑 ${times.first} min ago`)
        $(ELEMENT_ID_2).text(`🕑 ${times.second} min ago`)
        $(ELEMENT_ID_3).text(`🕑 ${times.third} min ago`)
    }

    if (elementExists(ELEMENT_ID_4) && elementExists(ELEMENT_ID_5) && elementExists(ELEMENT_ID_6)) {
        const times = {
            first: getRandomTime(1, 20),
            second: getRandomTime(20, 40),
            third: getRandomTime(40, 60),
        }

        $(ELEMENT_ID_4).text(`🕑 ${times.first} min ago`)
        $(ELEMENT_ID_5).text(`🕑 ${times.second} min ago`)
        $(ELEMENT_ID_6).text(`🕑 ${times.third} min ago`)
    }
}
